import type { FC } from 'react';

import { Typography } from '@mui/material';

import { useSelectedProjectTemplateNode } from 'state/selectedProject/selectedProjectHooks';
import { getNodeTypeName } from 'utils/names';

interface NodeTitleProps {
  templateNodeId: string;
}

export const NodeTitle: FC<NodeTitleProps> = ({ templateNodeId }) => {
  const projectTemplateNode = useSelectedProjectTemplateNode(templateNodeId);

  const title = projectTemplateNode ? getNodeTypeName(projectTemplateNode) : '';

  return (
    <Typography id='node-title' variant='h5' padding={(theme) => theme.spacing(1, 0)} flexGrow={0}>
      {title} details
    </Typography>
  );
};
